"use strict";
export class ImageHTML {
    constructor(token) {
        this.token = token;
    }
    render() {
        const imgSrc = this.token.url ? this.token.url.replace(/^\.?\//, "") : "";
        const altText = this.token.alt || "";
        const figcaptionBlock = altText
            ? `<figcaption class="md-image-caption">${altText}</figcaption>`
            : "";
        return `
    <div class="md-image-outer">
      <figure class="md-image-figure">
        <img src="${imgSrc}" alt="${altText}" class="md-image">
          ${figcaptionBlock}
      </figure>
    </div>
    `.trim();
    }
}
